module.exports = __webpack_public_path__ + "static/img/d14d9fee446dd9c99e023cc6f4cbac74.partners1.1709800931122.png";